import { mapToCamelCase, mapToSnakeCase } from '@consigli/utils';
export const createTransformer = (schema, name) => (data) => {
    const result = schema.safeParse(data);
    if (result.success) {
        return result.data;
    }
    // preferably we want to safeparse it with zod, but if that fails
    // we will just camelCase hand off the result
    console.warn(`Data mismatch in API call ${name}: `, result.error);
    return mapToCamelCase(data);
};
/**
 * This function takes an input object and transforms it into a new object suitable for use as query parameters.
 * It does this by iterating over each key-value pair in the input object and applying the following rules:
 * - If the value is undefined, an empty string, or an empty array, it is ignored.
 * - Otherwise, the value is copied as is.
 *
 * @param input - The input object to transform into query parameters.
 * @returns A new object with the transformed key-value pairs.
 */
export function createParams(input) {
    const params = {};
    for (const key in input) {
        if (input[key] !== undefined &&
            input[key] !== '' &&
            !(Array.isArray(input[key]) && input[key].length === 0)) {
            params[key] = input[key];
        }
    }
    return params;
}
// Export mapToSnakeCase for use in endpoint files
export { mapToSnakeCase };
